import React from 'react';
import styles from './index.module.scss';

const YoungAgeScreen = ({ backButtonClick }) => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>
        На жаль, <br></br>вік не підтверджено:(
      </p>
      <p className={styles.description}>
        Повернися на попередній крок і спробуй<br></br> пройти перевірку віку
        знову!
      </p>
      <button className={styles.backButton} onClick={backButtonClick}>
        <img
          className={styles.buttonGlowTop}
          src="/images/ua-lm-1test-auth/button-glow-top.svg"
          alt=""
        />
        <img
          className={styles.buttonGlowBottom}
          src="/images/ua-lm-1test-auth/button-glow-bottom.svg"
          alt=""
        />
        <span>Назад</span>
      </button>
    </div>
  );
};

export default YoungAgeScreen;
